// Centralized API base resolution.
//
// On a real domain (production custom domain or preview), we want all /api
// requests to go to the same origin as the page. This avoids:
//   - Cross-origin / CORS issues
//   - Safari Intelligent Tracking Prevention (ITP) blocking 3rd-party fetches
//   - Stale REACT_APP_BACKEND_URL values baked in at build time
//
// On localhost (local dev), fall back to whatever REACT_APP_BACKEND_URL says.

const ENV_URL = process.env.REACT_APP_BACKEND_URL || "";

const computeBackendUrl = () => {
  if (typeof window === "undefined" || !window.location || !window.location.origin) {
    return ENV_URL;
  }
  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    return ENV_URL;
  }
  return window.location.origin;
};

export const BACKEND_URL = computeBackendUrl();
export const API = `${BACKEND_URL}/api`;
